import ComparisonMode from 'enums/ComparisonMode'
import { CrosstabWidgetsType } from '../../types'

export const resolveSelection = (
  widgetSetting: CrosstabWidgetsType,
  rowId: string,
  colId: string
) => {
  const {
    rowComparisonMode,
    colComparisonMode,
    selectedTopic,
    topicInfos,
    pivotThemeInfos,
    pivotRowThemeInfos,
    tagNames,
    rowTagNames,
    docNames,
    rowDocNames
  } = widgetSetting

  let topic = selectedTopic
  let insight
  let pivot
  let selectedPivotThemeInfo
  let selectedPivotRowThemeInfo
  let selectedTagName
  let selectedRowTagName
  let selectedDocName
  let selectedRowDocName

  switch (rowComparisonMode) {
    case ComparisonMode.THEMES:
      if (pivotRowThemeInfos && pivotRowThemeInfos.length > 0) {
        selectedPivotRowThemeInfo = pivotRowThemeInfos?.find(
          (themeInfo) => themeInfo.themeId === parseInt(rowId, 10)
        )
        insight = {
          name: selectedPivotRowThemeInfo!.name,
          id: selectedPivotRowThemeInfo!.themeId?.toString()
        }
      }
      break

    case ComparisonMode.TAGS:
      if (rowTagNames && rowTagNames.length > 0) {
        selectedRowTagName = rowTagNames?.find((tagName) => tagName === rowId)
        insight = {
          name: selectedRowTagName,
          id: selectedRowTagName
        }
      }
      break

    case ComparisonMode.DOC_HIERARCHIES:
      if (rowDocNames && rowDocNames.length > 0) {
        selectedRowDocName = rowDocNames?.find((docName) => docName === rowId)
        insight = {
          name: selectedRowDocName,
          id: selectedRowDocName
        }
      }
      break

    default:
      topic =
        topicInfos?.find((topicInfo) => topicInfo.topicId === parseInt(rowId, 10)) || selectedTopic
      insight = {
        name: topic.name,
        id: topic.topicId?.toString()
      }
  }

  switch (colComparisonMode) {
    case ComparisonMode.THEMES:
      if (pivotThemeInfos && pivotThemeInfos.length > 0) {
        selectedPivotThemeInfo = pivotThemeInfos.find(
          (themeInfo) => themeInfo.themeId === parseInt(colId, 10)
        )
        pivot = {
          name: selectedPivotThemeInfo!.name,
          id: selectedPivotThemeInfo!.themeId?.toString()
        }
      }
      break

    case ComparisonMode.TAGS:
      if (tagNames && tagNames.length > 0) {
        selectedTagName = tagNames.find((tagName) => tagName === colId)
        pivot = {
          name: selectedTagName,
          id: selectedTagName
        }
      }
      break

    case ComparisonMode.DOC_HIERARCHIES:
      if (docNames && docNames.length > 0) {
        selectedDocName = docNames.find((docName) => docName === colId)
        pivot = {
          name: selectedDocName,
          id: selectedDocName
        }
      }
      break

    default:
      throw new Error(`Unsupported comparison mode: ${colComparisonMode}`)
  }

  return {
    insight,
    pivot,
    topic,
    selectedPivotThemeInfo,
    selectedPivotRowThemeInfo,
    selectedTagName,
    selectedRowTagName,
    selectedDocName,
    selectedRowDocName
  }
}

export const isClickingOnTotalColumn = (widgetSetting: CrosstabWidgetsType, x: number) => {
  const { colComparisonMode, pivotThemeInfos, tagNames, docNames } = widgetSetting

  switch (colComparisonMode) {
    case ComparisonMode.THEMES:
      if (!pivotThemeInfos || pivotThemeInfos.length === 0) {
        return x > 0
      }
      return x >= pivotThemeInfos.length

    case ComparisonMode.TAGS:
      if (!tagNames || tagNames.length === 0) {
        return x > 0
      }
      return x >= tagNames.length

    case ComparisonMode.DOC_HIERARCHIES:
      if (!docNames || docNames.length === 0) {
        return x > 0
      }
      return x >= docNames.length

    default:
      throw new Error(`Unsupported comparison mode: ${colComparisonMode}`)
  }
}
